module.exports = __webpack_public_path__ + "static/img/DirecTV-Default.dcf9590.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/destinations/DirecTV-Default.png
// module id = 1582
// module chunks = 0